import { Spinner, SpinnerSize } from 'office-ui-fabric-react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isFetchingHearingsSelector } from '../../../features/apiFeatures/hearingSlice';
import { shouldPaginateHearingsSelector } from '../../../features/bootstrapSlice';
import { getEntityId } from '../../../features/helpers/apiHelpers';
import {
  filterAndSortingKeys,
  noSelectionKey,
} from '../../../utilities/filterAndSortingsUtil';
import { HeaderWithCommandBar } from './HeaderWithCommandBar';
import { FiltersAndSortings } from './hearingOverview/FiltersAndSortings';
import { HearingList } from './hearingOverview/HearingList';
import { Pagination } from './pagination/Pagination';
import {
  areHearingsReadyForPageSelector,
  currentPageHearingsSelector,
  fetchHearingsForPage,
  filterAndSortingSelectionSelector,
  setActivePage,
  setFilterAndSortingSelection,
  setTitleFilter,
  titleFilterSelector,
  totalPagesHearingsSelector,
  updateCurrentPage,
  updateFilterAndSortingSelection,
} from '../../../features/componentFeatures/hearingOverviewSlice';
import { GetHearingsToRender } from '../../../utilities/GetHearingsToRender';
import { debounce } from '../../../utilities/debounce';

const HearingOverview = ({
  headerText,
  subHeadingText,
  initialShowGrid,
  hearingsSelector,
  disableEsdh,
  disableOwner,
  onHearingClick,
  onHearingSelect,
  disableSelection,
  activePage,
}) => {
  const dispatch = useDispatch();

  const [showGrid, setShowGrid] = useState(!!initialShowGrid);
  const [showTitleFilter, setShowTitleFilter] = useState(false);

  const filterAndSortingSelection = useSelector(
    filterAndSortingSelectionSelector,
  );

  const titleFilter = useSelector(titleFilterSelector);

  const usingPagination = useSelector(shouldPaginateHearingsSelector);
  const currentPage = useSelector(currentPageHearingsSelector);
  const totalPages = useSelector(totalPagesHearingsSelector);
  const hearingsReady = useSelector(areHearingsReadyForPageSelector);

  const isFetchingHearings = useSelector(isFetchingHearingsSelector);

  useEffect(() => {
    if (!activePage) {
      return;
    }
    dispatch(setActivePage(activePage));
    if (usingPagination) {
      dispatch(fetchHearingsForPage());
    }
  }, [dispatch, usingPagination, activePage]);

  const showSpinner = isFetchingHearings && !hearingsReady;
  const hearings = useSelector(hearingsSelector);
  let hearingIds = hearings.map((h) => getEntityId(h));

  const hearingsToRender = GetHearingsToRender(
    usingPagination,
    hearings,
    filterAndSortingSelection,
  );

  const onChangePage = (value) => dispatch(updateCurrentPage(value));

  const onSetFilterAndSortingSelections = (value) =>
    dispatch(updateFilterAndSortingSelection(value));

  const updateTitleFilter = debounce(onSetFilterAndSortingSelections, 400);

  const onSetTitleFilter = (value) => {
    dispatch(setTitleFilter(value));
    let currFilterAndSortingSelection = Object.assign(
      {},
      filterAndSortingSelection,
    );
    currFilterAndSortingSelection[filterAndSortingKeys.title] =
      value || noSelectionKey;

    updateTitleFilter(currFilterAndSortingSelection);
  };

  const onSetShowTitleFilter = function (value) {
    if (!value) {
      onSetTitleFilter(null);
    }
    setShowTitleFilter(value);
  };

  const onHearingClickCallback = (hearingItem) => {
    onHearingClick && onHearingClick(hearingItem);
  };
  return (
    <div className="admin-page">
      <div className="admin-page-container">
        <HeaderWithCommandBar
          header={headerText}
          subHeadingText={subHeadingText}
          showTitleFilter={showTitleFilter}
          setShowTitleFilter={onSetShowTitleFilter}
          titleFilter={titleFilter}
          setTitleFilter={onSetTitleFilter}
          showGrid={showGrid}
          setShowGrid={setShowGrid}
        />
        <FiltersAndSortings
          disableOwner={disableOwner}
          filterAndSortingSelection={filterAndSortingSelection}
          setFilterAndSortingSelection={onSetFilterAndSortingSelections}
          hearingIds={hearingIds}
        />
        {showSpinner ? (
          <Spinner size={SpinnerSize.large} />
        ) : (
          <HearingList
            items={hearingsToRender}
            showGrid={showGrid}
            disableEsdh={disableEsdh}
            disableOwner={disableOwner}
            sortingKey={
              filterAndSortingSelection[filterAndSortingKeys.sortingKey]
            }
            filterAndSortingSelection={filterAndSortingSelection}
            setFilterAndSortingSelection={setFilterAndSortingSelection}
            onHearingClick={onHearingClickCallback}
            onHearingSelect={onHearingSelect}
            disableSelection={disableSelection}
          />
        )}
        {usingPagination ? (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChangePage={onChangePage}
          />
        ) : null}
      </div>
    </div>
  );
};

export { HearingOverview };
